const TEST_ID = {
  global: {
    searchFilter: "search-filter",
  },

  respondents: {
    add_new_segment_btn: "add-new-segment-participant-id",
    segment_autocomplete: "segment-autocomplete",
    respondent_id: "respondent-id",
  },

  player: {
    play: "player-play",
    pause: "player-pause",
  },

  playlists: {
    title: "playlist-title",
  },

  project: {
    listing: "project-listing",
    accountsButton: "project-accounts-button",
    projectLink: "project-table-project-link",
  },

  account: {
    dashboard: "account-dashboard",
    settingsPage: "account-settings-page",
    settingsOwnersAccordion: "account-settings-owners-accordion",
    settingsPaymentsAccordion: "account-settings-payments-accordion",
    settingsLogoAccordion: "account-settings-logo-accordion",
    openSettings: "account-open-settings",
    listing: "accounts-listing",
    addButton: "accounts-add-new",
    form: {
      name: "accounts-form-name",
      addOwner: "accounts-form-add-owner",
      package: "accounts-form-package",
      featureAiInsights: "accounts-form-feature-ai-insights",
      featurePersonas: "accounts-form-feature-personas",
      featureProjectSearch: "accounts-form-feature-project-search",
    },
    table: {
      accountLink: "accounts-table-account-link",
      featureAiInsights: "accounts-table-feature-ai-insights",
      featurePersonas: "accounts-table-feature-personas",
      featureProjectSearch: "accounts-table-feature-project-search",
      settings: "accounts-table-settings",
    },
    autocompleteDeleteOption: "accounts-autocomplete-delete-option",
  },

  videoListing: {
    videoTitle: "video-title",
    showAllMedia: "show-all-media",
    groupByParticipant: "group-by-participant",
    groupByQuestion: "group-by-question",
    groupByInsight: "group-by-insight",
    reviewAll: "review-all",
  },

  videoReview: {
    pickerPrevious: "picker-previous",
    pickerNext: "picker-next",
  },

  timeline: {
    duration: "timeline-duration",
  },

  segment: {
    addNewButton: "segment-add-new",
    addSubmit: "segment-add-submit",
    segmentTextInput: "segment-text-input",
    removeSegment: "segment-remove",
    select: "segment-select",
  },

  tags: {
    tagButton: "tag-button",
    tagAutocompleteInput: "tag-autocomplete-input",
    addTagButton: "add-tag-button",
    updateTagButton: "update-tag-button",
  },

  transcript: {
    transcriptComponentWrapper: "transcript-component-wrapper",
    transcriptWord: "transcript-word",
  },

  login: {
    mfaCodeInput: "login-mfa-code-input",
    mfaResend: "login-mfa-resend",
    mfaRememberDevice: "login-mfa-remember-device",
    mfaSubmit: "login-mfa-submit",
  },

  admins: {
    twoFactorSwitch: "admins-two-factor-switch",
  },

  personas: {
    sidebarNav: "personas-sidebar-nav",
  },

  participantSignup: {
    qrAction: "participant-signup-qr-action",
    qrDialog: "participant-signup-qr-dialog",
    form: "participant-signup-form",
    firstName: "participant-signup-first-name",
    lastName: "participant-signup-last-name",
    email: "participant-signup-email",
    submit: "participant-signup-submit",
    confirmation: "participant-signup-confirmation",
    downloadApp: "participant-signup-download-app",
    appStoreLink: "participant-signup-app-store",
    playStoreLink: "participant-signup-play-store",
  },

  documents: {
    sidebarNav: "documents-sidebar-nav",
    tab: "documents-tab",
    tabPanel: "documents-tab-panel",
    uploadButton: "documents-upload-button",
    metabaseEmbed: "documents-metabase-embed",
    siteStatsModeratedCard: "documents-site-stats-moderated-card",
    siteStatsMobileCard: "documents-site-stats-mobile-card",
    filePreview: "documents-file-preview",
  },

  hydra: {
    page: "hydra-page",
    keywordInput: "hydra-keyword-input",
    applyFilters: "hydra-apply-filters",
    selectMenu: "hydra-select-menu",
    selectAllMatching: "hydra-select-all-matching",
    deselectAll: "hydra-deselect-all",
    selectionCount: "hydra-selection-count",
    exportButton: "hydra-export-button",
    modifySelectionButton: "hydra-modify-selection-button",
    modifySelectionModal: "hydra-modify-selection-modal",
    resultsGrid: "hydra-results-grid",
    tileViewToggle: "hydra-results-view-tile",
    gridViewToggle: "hydra-results-view-datagrid",
    paginationBar: "hydra-pagination-bar",
    paginationNext: "hydra-pagination-next",
    paginationPrevious: "hydra-pagination-previous",
    paginationDisplayedRows: "hydra-pagination-displayed-rows",
  },
};

export default TEST_ID;
